import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next'
import dompurify from "dompurify";
import Notice5Img from "assets/Content/ghoststudio/notice5.jpg";


export default function Audition(props) {
  const { t } = useTranslation()
  const sanitizer = dompurify.sanitize;
  const { open, handleClose } = props;
  
  // 将内容按 <br /><br /> 分割成段落
  const bodyText = t("Popup.notice4.body");
  const paragraphs = bodyText.split('<br /><br />').filter(p => p.trim());
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="base-dialog-wrapper info-dialog-wrapper notice4-dialog-wrapper"
    >
      <div className="base-dialog-container">
        <button onClick={handleClose} className="close-btn"></button>
        <div className="base-dialog-inner">
          <div className="info-body notice4-body">
            <div className="info-inner notice4-inner">
              <div className="info-item notice4-image">
                <img src={Notice5Img} alt="notice4" />
              </div>
              <div className="info-item notice4-text">
                <div className="info-item__subTitle">
                  {paragraphs.map((paragraph, index) => (
                    <p 
                      key={index}
                      dangerouslySetInnerHTML={{ __html: sanitizer(paragraph.trim()) }}
                    ></p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}